// src/features/admin/pages/AdminToxListPage.tsx
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAdminRole } from "../AdminGuard";
import "../admin.css";

type Tox = { id:number; title:string; status:'DRAFT'|'PUBLISHED'|'ARCHIVED'; published_at?:string|null; image_url?:string|null; author_id?:number|null };

export default function AdminToxListPage() {
    const { roles, userId } = useAdminRole();
    const isAuthorOnly = roles.length > 0 && !roles.some(r => r === "ADMIN" || r === "SUPER_ADMIN");

    const [q, setQ] = useState("");
    const [status, setStatus] = useState<string>("");
    const [page, setPage] = useState(1);
    const [size] = useState(20);
    const [items, setItems] = useState<Tox[]>([]);
    const [total, setTotal] = useState(0);
    const totalPages = Math.max(1, Math.ceil(total / size));
    const nav = useNavigate();

    const load = async () => {
        const qs = new URLSearchParams({ page:String(page), size:String(size) });
        if (q) qs.set("q", q);
        if (status) qs.set("status", status);
        const data = await api(`/admin/tox?${qs.toString()}`);
        setItems(data.items || []); setTotal(Number(data.total || 0));
    };
    useEffect(()=>{ load(); /* eslint-disable-next-line */ }, [page, status]);

    const search = (e: React.FormEvent) => { e.preventDefault(); setPage(1); load(); };

    const setState = async (id:number, next:'DRAFT'|'PUBLISHED'|'ARCHIVED') => {
        await api(`/admin/tox/${id}`, { method:"PATCH", json:{ status: next }});
        await load();
    };
    const del = async (id:number) => {
        if (!confirm("삭제할까요? 이 작업은 되돌릴 수 없습니다.")) return;
        await api(`/admin/tox/${id}`, { method:"DELETE" });
        await load();
    };

    return (
        <div className="adm-page">
            <h2>Weekly Tox</h2>
            <div className="adm-toolbar">
                <form onSubmit={search} className="adm-search-form">
                    <input value={q} onChange={(e)=>setQ(e.target.value)} placeholder="제목 검색"
                           className="adm-input" style={{ width: 240 }} />
                    <select value={status} onChange={(e)=>setStatus(e.target.value)} className="adm-select">
                        <option value="">(전체)</option>
                        <option value="DRAFT">DRAFT</option>
                        <option value="PUBLISHED">PUBLISHED</option>
                        <option value="ARCHIVED">ARCHIVED</option>
                    </select>
                    <button className="adm-btn">검색</button>
                </form>
                <button onClick={()=>nav("/admin/tox/new")} className="adm-btn">새 글</button>
            </div>

            <table className="adm-table">
                <thead>
                    <tr><th>ID</th><th>제목</th><th>상태</th><th>발행일</th><th>액션</th></tr>
                </thead>
                <tbody>
                {items.map(it => (
                    <tr key={it.id}>
                        <td>{it.id}</td>
                        <td><Link to={`/admin/tox/${it.id}`}>{it.title}</Link></td>
                        <td>{it.status}</td>
                        <td>{it.published_at ? new Date(it.published_at).toLocaleString() : "-"}</td>
                        <td style={{ display:"flex", gap:6 }}>
                            {!isAuthorOnly && it.status !== "PUBLISHED" && <button onClick={()=>setState(it.id,'PUBLISHED')} className="adm-btn-outline">발행</button>}
                            {!isAuthorOnly && it.status === "PUBLISHED" && <button onClick={()=>setState(it.id,'ARCHIVED')} className="adm-btn-outline">보관</button>}
                            {(!isAuthorOnly || it.author_id === userId) && <button onClick={()=>nav(`/admin/tox/${it.id}`)} className="adm-btn-outline">수정</button>}
                            {(!isAuthorOnly || it.author_id === userId) && <button onClick={()=>del(it.id)} className="adm-btn-danger">삭제</button>}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>

            <div className="adm-pagination">
                <button disabled={page<=1} onClick={()=>setPage(1)}>⏮</button>
                <button disabled={page<=1} onClick={()=>setPage(p=>Math.max(1,p-1))}>◀</button>
                <span>{page} / {totalPages}</span>
                <button disabled={page>=totalPages} onClick={()=>setPage(p=>Math.min(totalPages,p+1))}>▶</button>
                <button disabled={page>=totalPages} onClick={()=>setPage(totalPages)}>⏭</button>
            </div>
        </div>
    );
}